import React from 'react';
import { useNavigate } from 'react-router-dom';

export const BreadCrumb = ({ items, callBack }) => {
    const navigate = useNavigate();

    const navigateTo = (url, callBackData) => {
        if (url)
            navigate(url);
        if (callBackData)
            callBack(callBackData);
    };
    return (
        <>
            <div className='bread-crumb'>
                <nav style={{ '--bs-breadcrumb-divider': '>' }} aria-label="breadcrumb">
                    <ol className="breadcrumb um-list">
                        {items.map((item, index) => (
                            <React.Fragment key={index}>
                                <li
                                    className={`breadcrumb-item ${index === items.length - 1 ? 'bb' : ''}`}
                                    aria-current="page"
                                    onClick={() => navigateTo(item.url, item.callBackData)}
                                >
                                    {item.label}
                                </li>
                                {index !== items.length - 1 && (
                                    <li className="breadcrumb-item arrow" aria-current="page">
                                        {'>'}
                                    </li>
                                )}
                            </React.Fragment>
                        ))}
                    </ol>
                </nav>                
            </div>
        </>
    )
}

